import { Box, Grid, LinearProgress, Typography } from '@mui/material'
import { MakeAmountStyle } from '@utils/dataHelper'
import { withStyles } from '@mui/styles'

const BorderLinearProgressMd = withStyles((theme) => ({
  root: {
    height: 12,
    borderRadius: 27,
    zIndex: 1,
    margin: '15px 10px 20px 10px'
  },
  colorPrimary: {
    backgroundColor: '#EBEBEB',
  },
  bar: {
    height: 12,
    borderRadius: 27,
    backgroundColor: '#0377A8',
  },
}))(LinearProgress);

const BorderLinearProgressSm = withStyles((theme) => ({
  root: {
    height: 12,
    borderRadius: 27,
    zIndex: 1,
    margin: '15px 0 0'
  },
  colorPrimary: {
    backgroundColor: '#EBEBEB',
  },
  bar: {
    height: 12,
    borderRadius: 27,
    backgroundColor: '#0377A8',
  },
}))(LinearProgress);


const ProgressBar = (props) => {
  const {
    preSale,
    stakes,
    staked,
    padding
  } = props;

  return (
    <>
      <Box className="staked-info">
        <Grid container sx={{ textAlign: 'center' }}>
          <Grid item xs={6}>
            <Typography
              className="text-blue-dark font-24 font-bold"
            >
              {stakes ? MakeAmountStyle(stakes) : 0}
            </Typography>
            <Typography
              className="font-sm font-bold"
            >
              STAKES
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              className="text-blue-dark font-24 font-bold"
            >
              ${staked ? MakeAmountStyle(staked, true) : 0}
            </Typography>
            <Typography
              className="font-sm font-bold"
            >
              STAKED
            </Typography>
          </Grid>
        </Grid>
      </Box>
      {padding === 'md' ? (
        <BorderLinearProgressMd
          variant="determinate"
          value={
            staked === 0
              ? 0
              : parseFloat(staked / preSale) * 100 > 100
                ? 100
                : parseFloat(staked / preSale) * 100
          }
        />
      ) : (
        <BorderLinearProgressSm
          variant="determinate"
          value={
            staked === 0
              ? 0
              : parseFloat(staked / preSale) * 100 > 100
                ? 100
                : parseFloat(staked / preSale) * 100
          }
        />

      )}
    </>
  )
}

export default ProgressBar